import { contextEmoji } from '../../lib/contextEmoji'

export default function ContextPill({ tag, children, as: Element = 'span', ...props }) {
  const icon = contextEmoji(tag)
  return <Element {...props}>{icon && <><span aria-hidden="true">{icon}</span>{' '}</>}{children ?? tag}</Element>
}
